module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/partner-five-794e8813fcc1c4f1246b85be33e603f8.png";